import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { LEGAL_PAGES } from '../data/meta'

export default function CookiePolicy() {
  const page = LEGAL_PAGES.cookies
  return (
    <>
      <SEO title={page.title} description={page.description} canonical={page.url} structuredData={{ '@context': 'https://schema.org', '@type': 'WebPage', name: page.title, description: page.description }} />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content">
          <h1>Cookie Policy</h1>
          <p>Last updated: July 2026</p>

          <h2>1. Essential Cookies Only</h2>
          <p>
            TRED-EX AI uses only essential cookies required for core functionality, such as authentication tokens and session management.
            We do not use third-party tracking or advertising cookies.
          </p>

          <h2>2. Payment Processor</h2>
          <p>
            Razorpay may set cookies necessary for secure payment processing. These are essential to complete transactions.
          </p>

          <h2>3. Managing Cookies</h2>
          <p>
            You can clear or block cookies through your browser settings. Disabling essential cookies may affect site functionality.
          </p>

          <h2>4. Consent</h2>
          <p>
            By continuing to use our site, you agree to the use of essential cookies as described in this policy.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
